

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { TableConfig } from './TableConfigInterface';

@Component
export default class ConectaTable extends Vue {
  @Prop({ default: false })
  selectable!: boolean;
  @Prop({
    default: (): TableConfig[] => [],
    required: true,
  })
  configs!: TableConfig[];
  @Prop({
    type: Array,
    default: (): any[] => [],
  })
  items!: any[];
  @Prop({ default: 'No se han encontrado resultados para la búsqueda.' })
  noDataMessage!: string;

  //TODO: crear una interfaz para la config
  // = [
  //   {
  //     header: {
  //       text: 'Dessert (100g serving)',
  //       align: 'left', //TODO: mojorar es alineamiento
  //       value: 'name',
  //     },
  //     property: 'name',
  //   },
  //   {
  //     header: { text: 'Calories', value: 'calories' },
  //     property: 'calories',
  //   },
  // ];

  pagination: any = {
    sortBy: 'name',
  };
  selected: any[] = [];

  properties = this.configs.map(config => config.property);

  headers = this.configs.map(config => config.header);

  //TODO: hacer logica para actiones

  toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.items.slice();
  }
  changeSort(column: any) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }
}
